import React from "react";
import { Breadcrumb as AntdBreadcrumb } from "antd";
import "./style.scss";

const Breadcrumb = ({ items }) => <AntdBreadcrumb items={items} />;

export default Breadcrumb;
